import { InputField } from '@/hooks/forms';

export function getIsFormSubmittable(inputFields: InputField[]): boolean {
	return inputFields.every(field => field.isValid);
}
